// Official Cosplay Singers assets & copy — sourced ONLY from the Media Kit and official images.

export const LOGO = "/photos/logo.png";

// Official photos — orientation-corrected & enhanced (served locally)
export const PHOTOS = {
  stage: "/photos/hero.jpg",        // live performance + Mermaid Melody ledwall
  portrait: "/photos/experience.jpg", // sezione "L'esperienza"
  crowd: "/photos/crowd_indoor.jpg", // audience heart-hands
};

export const GALLERY = [
  { src: "/photos/crowd_outdoor.jpg", alt: "Il pubblico sotto il palco, una sera d’estate", feature: true },
  { src: "/photos/singer_pink.jpg", alt: "Sul palco, dal vivo", tall: true },
  { src: "/photos/stage_dark.jpg", alt: "Quando si alzano le luci", wide: true },
  { src: "/photos/singer_blue.jpg", alt: "Sul palco, dal vivo" },
  { src: "/photos/singer_green.jpg", alt: "Sul palco, dal vivo" },
  { src: "/photos/meet_greet2.jpg", alt: "Il Meet & Greet", tall: true },
  { src: "/photos/stage_front.jpg", alt: "Dal vivo, insieme al pubblico", wide: true },
  { src: "/photos/crowd_indoor.jpg", alt: "La community che canta insieme" },
  { src: "/photos/meet_greet.jpg", alt: "Autografi e abbracci dopo il concerto", tall: true },
  { src: "/photos/santa_stage.jpg", alt: "Sul palco, tra il pubblico in festa", tall: true },
  { src: "/photos/signing_detail.jpg", alt: "Una firma, un ricordo che resta", wide: true },
  { src: "/photos/portrait2.jpg", alt: "Le Cosplay Singers", tall: true },
  { src: "/photos/portrait.jpg", alt: "Le Cosplay Singers, insieme", tall: true },
];

export const WORLDS = {
  magic: "/photos/worlds_magic.jpg",
  mermaid: "/photos/worlds_mermaid.jpg",
  titles: ["Mermaid Melody", "Sugar Sugar", "Aoi la speranza del cuore"],
};

export const SPOTIFY = {
  title: "Il nostro posto sicuro",
  cover: "/photos/spotify_cover.jpg",
  track: "https://open.spotify.com/intl-it/track/5xykKSqXD0FRvcYsvn541l",
  embed: "https://open.spotify.com/embed/track/5xykKSqXD0FRvcYsvn541l?utm_source=generator&theme=0",
};

export const CONTACT = {
  management: "Nicobenz Management",
  email: "info@cosplaysingers.it",
  phoneDisplay: "+39 392 329 0737",
  whatsapp: "393923290737",
  instagram: "https://www.instagram.com/cosplaysingers/",
  youtube: "https://www.youtube.com/c/CosplaySingers",
  tiktok: "https://www.tiktok.com/@cosplay.singers",
  facebook: "https://www.facebook.com/cosplaysingers",
};

export const TRAILER_YOUTUBE_ID = "GioiGwREjzo";

// Media Kit — "IL PERCORSO"
export const CONVENTIONS = [
  "Milano Comics & Games",
  "Parma Comics & Games",
  "Cerea Comics & Games",
  "Rimini Comix",
  "Vicenza Comics & Games",
  "Udine Comics & Games",
  "Ancona Comics & Games",
  "San Beach Comix",
];

// Media Kit copy — excerpts kept verbatim
export const HERO_SUB = "Le voci ufficiali italiane di Mermaid Melody — Principesse Sirene.";
export const HERO_LINE = "Non si sale su un palco per eseguire un repertorio. Si sale per restituire alle persone qualcosa che credevano di aver perso.";

export const ABOUT = [
  {
    n: "01",
    title: "L’origine",
    body: "Tre voci che prestavano il proprio timbro alle canzoni italiane di Mermaid Melody, chiamate a cantarle per la prima volta davanti a un pubblico vero. Poi il pubblico ha smesso di ascoltare e ha iniziato a cantare. Da lì è nato tutto il resto.",
  },
  {
    n: "02",
    title: "Il posto sicuro",
    body: "Non è uno slogan. È una promessa. Il posto sicuro non ha un indirizzo, non si trova su una mappa. Per un’ora, quel luogo torna raggiungibile.",
  },
  {
    n: "03",
    title: "Quando si alzano le luci",
    body: "Lo spettacolo dura circa sessanta minuti. Ma il tempo, dentro quella sala, smette quasi subito di contare. I testi scorrono sui ledwall e, dopo il primo ritornello, non si nota più la differenza tra chi conosce ogni parola e chi la sta imparando in quel momento.",
  },
  {
    n: "04",
    title: "Dopo l’ultimo applauso",
    body: "Il Meet & Greet non è un servizio aggiunto al programma. È il momento in cui l’emozione condivisa diventa qualcosa di personale. Ogni concerto inizia con una canzone e finisce con un abbraccio.",
  },
];

export const QUOTES = {
  origin: "Alcune canzoni finiscono. I ricordi no.",
  stage: "Il palco ci divide solo per pochi metri. La musica ci mette tutti dalla stessa parte.",
  crowd: "Ogni voce sul palco trova la sua eco nelle migliaia di voci davanti.",
};

export const BOOKING_BODY = "Chi sceglie le Cosplay Singers non aggiunge soltanto un concerto al proprio programma. Porta un momento che il pubblico continuerà a raccontare anche dopo essere tornato a casa.";

export const CHI_SONO = "Non sono una cover band. Non sono un karaoke su un palco più grande. Sono un progetto costruito attorno ai ricordi di chi le sceglie: un’esperienza che mette al centro chi ascolta, non chi canta.";

export const FOOTER_LINE = "Alcune canzoni finiscono. I ricordi no.";
